import React from 'react';
import { useTranslations } from 'next-intl';
export const EmptySearch: React.FC = () => {
  const t = useTranslations('shared.header');
  return <div className="flex h-full flex-col items-center justify-center" data-sentry-component="EmptySearch" data-sentry-source-file="EmptySearch.tsx">
      <p className="text-center text-base text-black">
        {t('searchResults.not_found')}
        <br />
        {t('searchResults.try_again')}
      </p>
    </div>;
};